/*
===============================================================================================================
                                 Copyright 2024-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

/* eslint-disable no-console */
import { isEmpty } from '@/utilities/validation';
import { updateCompanyRequest } from './company';
import compileChangeObject from './compile-change-object';

export default async ({
  changes: changeArray, merchantId, token,
  rootOrgId, productName, getConfigValue,
  sharedData,
}) => {
  if (isEmpty(changeArray)) return;

  const { storeNetworkIds, networks } = sharedData || {};
  const currentStoreNetworks = getConfigValue('storeNetworkConfig') || [];
  const changes = compileChangeObject(changeArray);

  const updatedStoreNetworks = storeNetworkIds?.map((id) => {
    const matchingNetwork = networks?.find((network) => network
      .storeNetworks.some((storeNetwork) => storeNetwork.storeNetworkId === id));

    return {
      storeNetworkId: id,
      enabled: true,
      storeNetworkCarrierId: matchingNetwork ? matchingNetwork.carrierCompanyId : null,
    };
  }) || [];

  const updatedList = currentStoreNetworks
    .filter((el) => !storeNetworkIds?.includes(el.storeNetworkId))
    .map((el) => ({ ...el, enabled: false }));

  const body = {
    products: {
      [productName]: {
        storeNetworkConfig: {
          selectedStoreNetworks: changes.deleteNetwork ? null : []
            .concat(updatedList)
            .concat(updatedStoreNetworks),
        },
        enabled: true,
      },
    },
  };
  try {
    await updateCompanyRequest({
      rootOrgId, merchantId, body, token,
    });
  } catch (e) {
    console.log('Could not update store network config');
    console.log(e);
    throw new Error(e);
  }
};
